import { API_BASE_URL } from '../config';

// Wraps fetch(): prepends the API base URL, attaches the admin's JWT if one
// is stored, and forces a re-login if the token is missing/expired/invalid.
export async function apiFetch(path, options = {}) {
  const token = localStorage.getItem('token');
  const headers = { ...(options.headers || {}) };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const response = await fetch(`${API_BASE_URL}${path}`, { ...options, headers });

  if (response.status === 401) {
    localStorage.removeItem('token');
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
  }

  return response;
}
